import { DataSourceOption } from 'src/constants/dataSourceTypeDescription';
import { SqlDataSource } from 'src/store/state/dataSources';

export const SAMPLE_MUSIC_DATA_SOURCE: SqlDataSource = {
  entityName: '',
  available: true,
  sharable: true,
  id: 'sample_music_demo',
  type: 'MYSQL',
  options: {
    [DataSourceOption.ENDPOINT]:
      'jdbc:mysql://stardogtraining.ck0sw5wyh0fl.us-east-1.rds.amazonaws.com/music?useSSL=false&requireSSL=false',
    [DataSourceOption.USERNAME]: 'sampledatauser',
    [DataSourceOption.PASSWORD]: '$ecretPassw0rd',

    // set these so that if the database's connection resets,
    // we reconnect instead of staying in a broken state
    testOnBorrow: 'true',
    validationQuery: 'SELECT 1',
  },
  tables: [],
  tableMetadataErrorResponse: null,
};
